import ReducersSagaRegistryTypes from 'yoda-site-components/lib/actionTypes/ReducerSagaRegistryActionTypes';

export default reducerSagaRegistry => store => next => (action) => { // eslint-disable-line
    const { type, payload } = action;

    switch (type) {
        case ReducersSagaRegistryTypes.INJECT_REDUCER: {
            return reducerSagaRegistry.injectReducer(payload);
        }
        case ReducersSagaRegistryTypes.REJECT_REDUCER: {
            return reducerSagaRegistry.rejectReducer(payload);
        }
        case ReducersSagaRegistryTypes.INJECT_SAGA: {
            return reducerSagaRegistry.injectSaga(payload);
        }
        case ReducersSagaRegistryTypes.REJECT_SAGA: {
            return reducerSagaRegistry.rejectSaga(payload);
        }
        default:
            return next(action);
    }
};
